const menu = {
    label: 'Instituições',
    icon: 'pi pi-fw pi-home',
    to: '/mapaparceiros/pessoa/parceiro',
    rules: ['MAPAPARC-PES-00'],
};

export default menu;